// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
let url = 'http://localhost:8000/';
url = 'https://bkamvv.torneosbo.com/';

export const environment = {
  env: 'DEFAULT',
  production: false,
  serverBaseUrl: url + 'api',
  serverUrl: url + 'api',
  imgUrl: url + '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
